import axios from 'axios';
import { getAccessTokenBrowser } from 'helpers/auth';
import { getApiUrl } from './constants';

export type PoliciesResult = {
	polices: {
		insurance: string;
	}[];
	permission: boolean;
	success: boolean;
};

export type ChangePolicyPermissionResult = boolean;

export const getPolicies = async (hostname: string): Promise<PoliciesResult> => {
	const accessToken = await getAccessTokenBrowser();
	const headers = {
		Authorization: 'Bearer ' + accessToken,
		hostname: hostname,
	};
	const { href } = getApiUrl('Policy/GetPolicies');

	const { data } = await axios.get<PoliciesResult>(href, { headers: headers });
	return data;
};

export const changePolicyPermission = async (hostname: string, membershipId: string): Promise<ChangePolicyPermissionResult> => {
	const accessToken = await getAccessTokenBrowser();
	const headers = {
		Authorization: 'Bearer ' + accessToken,
		hostname: hostname,
		'Content-Type': 'application/json',
	};
	const { href } = getApiUrl(`InsurancePermission/ChangePolicyPermission`);

	const { data } = await axios.put<ChangePolicyPermissionResult>(href, JSON.stringify(membershipId), { headers: headers });
	return data;
};
